import React, { useState } from "react";
import Modal from 'react-awesome-modal';
import { observer } from "mobx-react";
import store from '../Stores/SurveyStore'
import ibsStore from '../Stores/IbsSurveyStore'
//import sharedStore from '../Stores/SharedStore'
import {setTempAnalystCommentValue, getCommentValue, dateFormatter, errorExplanationOptions} from '../../helpers'
import { addAnalystComment, insertRowCtrl, getAssetStyleForCategory, updateMandateInfoCtrl, deleteMandateDataCtrl, addMandateRowCtrl, addBenchmarkRow, addMandateLPCtrl } from "../../control"
import { DropDownList, Multi, MultiSelect } from "@progress/kendo-react-dropdowns";
import { toJS } from "mobx";
import { AssetStyleDefinitions, AssetClassDefinitions } from "../../Enums/assetsDefinitions";
import {CURRENT_DATA_YEAR, ElementType, SelectCombosIBS} from "../../Enums/constants";
import { getTableDataDb, addMandateLP } from "../../Services/IBS/DbService";
import {Tooltip} from "react-tippy";
import SurveySelect from "../SurveySelect";
import SurveyElement from "../SurveyElement";
import { mandateRegionOptions, mandateSubstyleOptions, convertMandateSubstyleToID, mandateSubstylesForAsset, mandateSubstylesForAssetChosenRemoved } from "../../ibsHelper";


const AddRowModal = observer((props) => {
    const [value, setValue] = useState([]);
    //setValue(ibsStore.mandateModalInfo.MandateSubstyles)
    let showVintageYearFlag = (ibsStore.mandateModalInfo.AssetCatID === 3 || ibsStore.mandateModalInfo.AssetCatID === 5 || ibsStore.mandateModalInfo.AssetCatID === 7) && (ibsStore.mandateModalInfo.StyleID === 9 || ibsStore.mandateModalInfo.StyleID === 16)
    let showCommitPeriodFlag = ibsStore.mandateModalInfo.StyleID === 16
    const saveMandateModal = () => {
        //if (!validVintageYearCheck()) return null
        updateMandateInfoCtrl()
        closeAddRowModal()
        
    }
    const validVintageYearCheck = () => {
        if (ibsStore.mandateModalInfo.VintageYear > ibsStore.currentSurvey.DataYear || ibsStore.mandateModalInfo.VintageYear < 1980 && showVintageYearFlag) {
            alert("Invalid Vintage Year")
            return false
        }
        return true
    }
    const addNewMandate = async () => {
        //if (!validVintageYearCheck()) return null
        //check if asset class exists
        let assetAlreadyExists = ibsStore.allTableResponses["combinedAssets"].findIndex(row => (row.AssetClassID === ibsStore.mandateModalInfo.AssetClassID && row.StyleID ===ibsStore.mandateModalInfo.StyleID));
        if (assetAlreadyExists == -1) {
            await insertRowCtrl(ibsStore.mandateModalInfo.AssetClassID, ibsStore.mandateModalInfo.StyleID, "CombinedDBTable");
        }
        ibsStore.mandateCategoryToRender = "All"
        addMandateRowCtrl()
        closeAddRowModal()
    }

    const openAssetStyleSelecter = () => {
        store.showAddRowModal = true;
    }

    const deleteMandate = async () => {
        let confirmed = window.confirm("Are you sure you want to delete this mandate?");
        if (confirmed) {
            await deleteMandateDataCtrl()
            await closeAddRowModal()
        }
    }


    const onChange = (name, e) => {
        if (name == "VintageYear" && e.target.value.length > 4) {
            //if vintage year, cap at 4 and make sure its a year
            return null
        }
        else if (name == "CommitmentEndYear" && e.target.value.length > 4) {
            //if CommitmentEndYear, cap at 4 and make sure its a year
            return null
        }
        ibsStore.mandateModalInfo[name] = e.target.value

    };

    const onClickCheckbox = (name, e) => {
        ibsStore.mandateModalInfo[name] = !ibsStore.mandateModalInfo[name]

    }

    const saveRow = async () => {
        if (store.addingBenchmark) {
            addBenchmarkRow(store.rowDetails.AssetClassId)
        } else {
            await insertRowCtrl(store.rowDetails.AssetClassId, store.rowDetails.ImplementationStyleId, "CombinedDBTable", store.rowDetails.CategoryId)
        }
        closeAddRowModal()
    }

    
    const closeAddRowModal = async () => {
        store.showAddRowModal = false;
        for (const member in store.rowDetails) store.rowDetails[member] = "";
        store.showAssetOptions = false;
        store.showImplementationOptions = false;

        //handle mandate
        for (const member in ibsStore.mandateModalInfo) ibsStore.mandateModalInfo[member] = "";
        //setValue([])
        ibsStore.mandateModalInfo.MandateSubstyles = []
        ibsStore.mandateModalInfo.IsSingleMandate = true;
        store.addingNewMandate = false;
        store.editingMandate = false;
        store.showMandateActionModal = false;
        store.addingBenchmark = false;
    }

    const onChangeAssetClass = (categoryId, assetClassId, assetClassName, e, definitionID) => {
        store.rowDetails.CategoryId = categoryId
        store.rowDetails.AssetClassId = assetClassId
        store.rowDetails.AssetClassName = assetClassName
        store.rowDetails.StyleDescription = ""
        store.rowDetails.ImplementationStyleId = "";
        store.rowDetails.ImplementationStyleName = "";
        ibsStore.mandateModalInfo.StyleName = ""
        ibsStore.mandateModalInfo.MandateSubstyles = []
        /*
            Missing:
                5,6,7,8,9,10,11,12,13,14,15,19,20,21,22,23,26,27,31,32,35,60,61,62,63,64,65,66,70,71,72,73,74,75,76,77,78,79,80,81,82,83
                Balanced Funds, CKDS, Commodities, Domestic Property, Fixed Income - Absolute Return Bonds, Fixed Income - Asia-Pacific, Fixed Income - Australia, Fixed Income - Canada, Fixed Income - EAFE ex-Australia, Fixed Income - EAFE ex-UK, Fixed Income - Euro, Fixed Income - Euro Credit, Fixed Income - Euro Gov't, Fixed Income - Global Credit, Fixed Income - Global Gov't, Fixed Income - Home Country, Fixed Income - UK, Fixed Income - UK Credit, Fixed Income - UK Gov't, Mexican - Credit, Mexican - Credit Financials, Mexican - Credit Non-Financials, Mexican - Government, Mexican Government & Credit, Private Debt, Stock - Asia-Pacific, Stock - Asia-Pacific ex-Japan, Stock - Australia, Stock - Canada, Stock - EAFE ex-Australia, Stock - Emerging, Stock - Europe, Stock - Europe ex-UK, Stock - Europe Small Cap, Stock - Global, Stock - Global Small Cap, Stock - Home Country, Stock - Japan, Stock - UK, Stock Mexican
        */
        switch (assetClassId) {
          //AssetClassCategory: Equities (1)
          case (1):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.US_BROAD_ALL;
            break;
          case (2):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.US_LARGE_CAP;
            break;
          case (3):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.US_SMALL_CAP;
            break;
          case (4):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.EAFE;
            break;
          case (7):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.ASIA_PACIFIC;
            break;
          case (11):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.EMERGING;
            break;
          case (12):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.GLOBAL;
            break;
          case (13):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.GLOBAL_SMALL_CAP;
            break;
          case (16):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.OTHER_EQUITY;
            break;
          case (47):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.EMPLOYER_STOCK;
            break;
          case (55):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.ACWI_US;
            break;
          case (67):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.US_MID_CAP;
            break;

          //AssetClassCategory: Bonds (2)
          case (24):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.EMERGING_BONDS;
            break;
          case (25):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.GLOBAL_BONDS;
            break;
          case (17):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.US;
            break;
          case (18):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.EAFE_BONDS;
            break;
          case (19):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.FIXED_INCOME_EURO;
            break;
          case (20):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.FIXED_INCOME_ASIA_PACIFIC;
            break;
          case (22):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.FIXED_INCOME_UK;
            break;
          case (26):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.FIXED_INCOME_GLOBAL_GOVT;
            break;
          case (27):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.FIXED_INCOME_GLOBAL_CREDIT;
            break;
          case (28):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.INFLATION_INDEXED;
            break;
          case (29):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.HIGH_YIELD;
            break;
          case (33):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.OTHER_BONDS;
            break;
          case (34):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.CASH;
            break;
          case (56):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.LONG_BONDS;
            break;
          case (61):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.FIXED_INCOME_UK_GOVT;
            break;
          case (62):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.FIXED_INCOME_UK_CREDIT;
            break;
          case (65):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.FIXED_INCOME_EURO_GOVT;
            break;
          case (66):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.FIXED_INCOME_EURO_CREDIT;
            break;
          case (68):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.US_CREDIT;
            break;
          case (69):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.US_GOVT;
            break;
          case (84):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.BUNDLED_LDI;
            break;
          case (85):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.CONVERTIBLES;
            break;

          //AssetClassCategory: Real Assets (3)
          case (36):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.INFRASTRUCTURE;
            break;
          case (37):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.REITS;
            break;
          case (38):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.NATURAL_RESOURCES;
            break;
          case (39):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.REAL_ESTATE;
            break;
          case (40):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.OTHER_REAL_ASSETS;
            break;

          //AssetClassCategory: Multi-Asset Strategies (4)
          case (41):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.HEDGE_FUND;
            break;
          case (42):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.FUNDED_TAA;
            break;
          case (86):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.RISK_PARITY;
            break;

          //AssetClassCategory: Private Equity (5)
          case (43):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.DIVERSIFIED_ALL;
            break;
          case (44):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.VENTURE_CAPITAL;
            break;
          case (45):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.LBO;
            break;
          case (46):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.OTHER_NON_LISTED;
            break;

          //AssetClassCategory: Derivatives/Overlays (6)
          case (48):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.CURRENCY_HEDGE;
            break;
          case (49):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.REBALANCING_PASSIVE_BETA;
            break;
          case (50):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.DUR_MGMT;
            break;
          case (51):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.GLOBAL_TAA_OVERLAY;
            break;
          case (52):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.COMMODITY_FUTURES;
            break;
          case (53):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.LONG_SHORT;
            break;
          case (54):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.OTHER_OVERLAY;
            break;
          case (57):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.POLICY_TILT_TAA;
            break;
          case (58):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.DUR_MGMT_INTREST;
            break;
          case (59):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.DUR_MGMT_SWAPS;
            break;
          case (87):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.INFLATION_LINKED;
            break;
          case (89):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.DUR_MGMT_TREASURY;
            break;

          //AssetClassCategory: Private Debt (7)
          case (30):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.MORTGAGES;
            break;
          case (88):
            store.rowDetails.AssetClassDescription = AssetClassDefinitions.PRIVATE_CREDIT;
            break;


          default:
            store.rowDetails.AssetClassDescription = "";
            break;
        }
        store.showAssetOptions = false;
        store.showImplementationOptions = true;
        displayStyleNames(categoryId, assetClassId)

        ibsStore.mandateModalInfo.AssetClassName = assetClassName
        ibsStore.mandateModalInfo.AssetClassID = assetClassId
        ibsStore.mandateModalInfo.AssetCatID = categoryId
        //set definition here!!
    }

    const onChangeImplementation = (classId, impId, impName) => {
        store.rowDetails.ImplementationStyleId = impId
        store.rowDetails.ImplementationStyleName = impName
        store.rowDetails.StyleDescription = "";

        ibsStore.mandateModalInfo.StyleName = impName
        ibsStore.mandateModalInfo.StyleID = impId
        ibsStore.mandateModalInfo.VintageYear=""
        switch (impId) {
            case (1):
                store.rowDetails.StyleDescription = AssetStyleDefinitions.INTERNAL_PASSIVE;
                break;
            case (3):
                store.rowDetails.StyleDescription = AssetStyleDefinitions.INTERNAL_ACTIVE;
                break;
            case (5):
                store.rowDetails.StyleDescription = AssetStyleDefinitions.EXTERNAL_PASSIVE;
                break;
            case (7):
                store.rowDetails.StyleDescription = AssetStyleDefinitions.EXTERNAL_ACTIVE;
                break;
            case (9):
                store.rowDetails.StyleDescription = AssetStyleDefinitions.FUND_OF_FUND;
                break;
            case (10):
                store.rowDetails.StyleDescription = AssetStyleDefinitions.CO_INVESTMENT;
                break;
            case (13):
                store.rowDetails.StyleDescription = AssetStyleDefinitions.EVERGREEN;
                break;
            case (16):
                if (classId === 43 || classId === 44 || classId === 45 || classId === 46) {
                    store.rowDetails.StyleDescription = AssetStyleDefinitions.FUND_LP;
                } else {
                    store.rowDetails.StyleDescription = AssetStyleDefinitions.LIMITED_LIFE_FUND;
                }
                break;  
            case (18):
                store.rowDetails.StyleDescription = AssetStyleDefinitions.JOINT_VENTURE;
                break;
            case (11):
                if (classId === 39) {
                    // only use this for Real Estate - 39
                    store.rowDetails.StyleDescription = AssetStyleDefinitions.INTERNAL_DIRECT;
                } else {
                    store.rowDetails.StyleDescription = "";
                }
                break;
            default:
                store.rowDetails.StyleDescription = "";
                break;
        }
       
        //store.rowDetails.StyleDescription = "test test description"
        store.showImplementationOptions = false
        store.showSubstylesOptions = true;
    };

    const showHideAssetOptions = () => {
        store.showAssetOptions = !store.showAssetOptions
        store.showImplementationOptions = false
    }
    const showHideImpOptions = () => {
        if (store.rowDetails.CategoryId != "") {
            store.showImplementationOptions = !store.showImplementationOptions
            store.showAssetOptions = false
            displayStyleNames(ibsStore.mandateModalInfo.AssetCatID , ibsStore.mandateModalInfo.AssetClassID)


        } else if (store.rowDetails.CategoryId == "" && !store.editingMandate) {
            alert("Select an asset class first!")
        } else {
            store.showImplementationOptions = !store.showImplementationOptions
            store.showAssetOptions = false
            displayStyleNames(ibsStore.mandateModalInfo.AssetCatID, ibsStore.mandateModalInfo.AssetClassID)
            store.showSubstylesOptions = true;
        }

    }
    const showHideSubstyleOptions = () => {
        if (store.rowDetails.ImplementationStyleName != "") {
            store.showSubstylesOptions = true
            store.showImplementationOptions = false


        } else if (store.rowDetails.ImplementationStyleName == "" && !store.editingMandate) {
            alert("Select an implementation style first!")
        } else {
            store.showSubstylesOptions = !store.showSubstylesOptions
            store.showImplementationOptions = false

        }

    }
  
    const checkIfStyleInTable = (assetId, styleId, catId) => {
        var stylesForAssetAvailable = []
        
            ibsStore.allTableResponses["combinedAssets"] && ibsStore.allTableResponses["combinedAssets"].forEach(row => {
                if (row.AssetClassID === assetId && row.StyleID === styleId && row.AssetClassCategoryID === catId) {
                    stylesForAssetAvailable.push(row)
                }

            }
            );
       
        if (stylesForAssetAvailable.length>0) return true
        return false;
    }
    const checkIfAssetInTable = (assetId, catId) => {
        var assetsAvailable = []
        if (store.addingBenchmark) {
            ibsStore.allTableResponses["Benchmark"] && ibsStore.allTableResponses["Benchmark"].forEach(row => {
                if (row.AssetClassID === assetId && row.AssetClassCategoryID === catId) {
                    assetsAvailable.push(row)
                }
            }
            );
        }
       
        if (assetsAvailable.length > 0) return true
        return false;
    }

    const countStyles = (catId, assetId) => {
        let stylesAvail = [];
        let catName = "cat" + catId
        var stylesForAsset = ibsStore.assetStylesForCat[catName].filter(type => type.Key.AssetClassID === assetId);
        if (stylesForAsset[0]) {
            stylesForAsset[0].grp.forEach(element => {
                //check if in table first //can skip this call if in mandate mode
                var existsInTable = checkIfStyleInTable(element.AssetClassID, element.StyleID, catId)
                if (!existsInTable || (store.addingNewMandate || store.editingMandate)) {
                    stylesAvail.push({ name: element.StyleName, id: element.StyleID })
                }
            }
            );
        }
        return (stylesAvail.length)
    }

    const displayStyleNames = (catId, assetId) => {
        ibsStore.styleOptions = [];
        let catName = "cat" + catId
        var stylesForAsset = ibsStore.assetStylesForCat[catName].filter(type => type.Key.AssetClassID === assetId);
        if (stylesForAsset[0]) {
            stylesForAsset[0].grp.forEach(element => {
                //check if in table first //can skip this call if in mandate mode
                var existsInTable = checkIfStyleInTable(element.AssetClassID, element.StyleID, catId)
                if (!existsInTable || (store.addingNewMandate || store.editingMandate || store.addingBenchmark)) {
                    ibsStore.styleOptions.push({ name: element.StyleName, id: element.StyleID })
                }
            }
            );
        }
    }

    const renderModalTitle = () => {
        if (store.addingNewMandate) return (<h3> <i className="fa fa-edit"></i> Add mandate</h3>)
        else if (store.editingMandate) return (<h3> <i className="fa fa-edit"></i> Edit mandate</h3>)
        else if (store.addingBenchmark) return (<h3> <i className="fa fa-edit"></i> Insert new benchmark</h3>)
        else return (<h3> <i className="fa fa-edit"></i> Insert new asset class/style</h3>)
    }
    const showAssetStyleDetails = () => {
        if (store.editingMandate) {
            return (<div className="row">
                <div className="col-md-12">
                    <span className="comment-heading">Asset class name: &nbsp; </span>
                    <span className=""> {ibsStore.mandateModalInfo.AssetClassName} </span> &nbsp;&nbsp;&nbsp;
                            <span className="comment-heading">Style name: &nbsp; </span>
                    <span className=""> {ibsStore.mandateModalInfo.StyleName} </span>


                </div>
            </div>);
        }
        return null;
        
    }

    const getPast12Years = () => {
        let years = []
        let latestYear = 2020
        let i;
        for (i = 0; i <= 12; i++) {
            years.push(latestYear-i)
        }
        return years
    }
  
    //TODO: connect vintage year to database value
    const mandateOnlySection = () => {
        let indivNoteSpacing = ibsStore.currentSurvey?.PlanPartnershipID === 6 ? '250px' : '200px';
        if (store.addingNewMandate || store.editingMandate) {
            return (
                <React.Fragment>
                    <div className="row">
                        <div className="col-md-3">
                            <span className="comment-heading">Manager name<sup>*</sup>
                            <Tooltip
                                disabled={false}
                                position="right-end"
                                trigger="mouseenter"
                                arrow="true"
                                delay={250}
                                size="small"
                                interactive="false"
                                hideOnClick="false"
                                animation="fade"
                                html={(
                                    <div className="genericTooltip">
                                        <span>Input "Internal" if the mandate is internally managed.<br /><br />Input "Aggregate" If you want to input an aggregate of multiple mandates with the same asset class and implementation style. Do not aggregate mandates with different implementation styles.</span>
                                    </div>
                                )}
                                popperOptions={{
                                    modifiers: {
                                        preventOverflow: {
                                            enabled: true,
                                        },
                                        flip: {
                                            enabled: true,
                                        },
                                        addZIndex: {
                                            enabled: true,
                                            order: 810,
                                            fn: data => ({
                                                ...data,
                                                styles: {
                                                    ...data.styles,
                                                    zIndex: 999999,
                                                },
                                            })
                                        }
                                    },
                                }}
                            >
                                <i className="fas fa-info-circle fa-xs"></i>
                            </Tooltip>
                            </span> 
                        </div>

                        <div className="col-md-9" style={{ marginTop: '10px' }}>

                                <input type="text" onChange={(e) => onChange('ManagerName', e)} className="textInput textFields" name={""} value={ibsStore.mandateModalInfo.ManagerName} />
                            </div>

                       
                    </div>

                    <div className="row">

                        <div className="col-md-3" style={{ marginTop: '10px' }}>
                            <span className="comment-heading">Fund name<sup>*</sup></span>  &nbsp;
                            </div>
                        <div className="col-md-9" style={{ marginTop: '10px' }}>
                            <input type="text" onChange={(e) => onChange('FundName', e)} className="textInput textFields" name={""} value={ibsStore.mandateModalInfo.FundName} />
                        </div>


                    </div>
                    <div className="row">

                        <div className="col-md-3" style={{ marginTop: '10px' }}>
                            <span className="comment-heading">Internal identifier
                            <Tooltip
                                disabled={false}
                                position="right-end"
                                trigger="mouseenter"
                                arrow="true"
                                delay={250}
                                size="small"
                                interactive="false"
                                hideOnClick="false"
                                animation="fade"
                                html={(
                                    <div className="genericTooltip">
                                        <span>This is a unique ID you use internally to identify this mandate. This is an optional field but it is recommended that you provide the internal identifier in case you are anonymising the Manager name and Fund name. The unique ID ensures the holdings, costs and returns get reported for the correct mandate year over year.</span>
                                    </div>
                                )}
                                popperOptions={{
                                    modifiers: {
                                        preventOverflow: {
                                            enabled: true,
                                        },
                                        flip: {
                                            enabled: true,
                                        },
                                        addZIndex: {
                                            enabled: true,
                                            order: 810,
                                            fn: data => ({
                                                ...data,
                                                styles: {
                                                    ...data.styles,
                                                    zIndex: 999999,
                                                },
                                            })
                                        }
                                    },
                                }}
                            >
                                <i className="fas fa-info-circle fa-xs"></i>
                            </Tooltip>
                            </span> 
                        </div>
                        <div className="col-md-9" style={{ marginTop: '10px' }}>
                            <input type="text" onChange={(e) => onChange('AccountCode', e)} className="textInput textFields" name={""} value={ibsStore.mandateModalInfo.AccountCode} />
                    </div>



                    </div>
                    
                    <div className="row">
                        <div className="col-md-3" style={{ marginTop: '10px' }}>
                            <span className="comment-heading">Region<sup>*</sup>
                            </span>
                        </div>
                        <div className="col-md-9">
                            <DropDownList
                                className={"regionSelectMandatesModal"}
                                data={mandateRegionOptions()}
                                value={ibsStore.mandateModalInfo.MandateRegionID}
                                onChange={(e) => {
                                    onRegionChange(e)
                                }}
                            />
                        </div>
                    </div>
                   
                    {(showVintageYearFlag) &&
                    <div className="row">
                        <div className="col-md-3" style={{marginTop: '10px'}}>
                            <span className="comment-heading" style={{ marginRight: '38px' }}>Vintage year</span>  &nbsp;
                        </div>
                        <div className="col-md-9" style={{ marginTop: '10px' }}>
                            <input type="number" onChange={(e) => onChange('VintageYear', e)}
                                className="textInput textFields" name={""} placeholder={"YYYY"} max={"4"}
                                   value={ibsStore.mandateModalInfo.VintageYear}/>
                        </div>
                    </div>
                    }

                    <div className="row">
                        <div className="col-md-12" style={{ marginTop: '13px' }}>
                            <span className="comment-heading">Details:</span>  &nbsp;
                            <span style={{ paddingLeft: '165px' }}>

                            {(ibsStore.currentSurvey.PlanPartnershipID === 6) &&
                                <React.Fragment>
                                        <input type='checkbox' name="cb1" id="cb1"
                                            checked={ibsStore.mandateModalInfo.IsLgpsPoolOptions}
                                            onClick={(e) => onClickCheckbox('IsLgpsPoolOptions')} />
                                        <label htmlFor='cb1'>LGPS Pool</label>&nbsp;&nbsp;&nbsp;
                                </React.Fragment>
                                }
                                <span className="indivMandate">
                                <input type='checkbox' name="cb2" id="cb2" 
                                        checked={ibsStore.mandateModalInfo.IsSingleMandate}
                                        onClick={(e) => onClickCheckbox('IsSingleMandate', e)} />
                                    <label htmlFor='cb2'>Individual mandate</label>
                                   
                                    <Tooltip
                                        disabled={false}
                                        position="right-end"
                                        trigger="mouseenter"
                                        arrow="true"
                                        delay={250}
                                        size="small"
                                        interactive="false"
                                        hideOnClick="false"
                                        animation="fade"
                                        html={(
                                            <div className="genericTooltip">
                                                <span>Uncheck this box if this is an aggregate of multiple mandates.</span>
                                            </div>
                                        )}
                                        popperOptions={{
                                            modifiers: {
                                                preventOverflow: {
                                                    enabled: true,
                                                },
                                                flip: {
                                                    enabled: true,
                                                },
                                                addZIndex: {
                                                    enabled: true,
                                                    order: 810,
                                                    fn: data => ({
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            zIndex: 999999,
                                                        },
                                                    })
                                                }
                                            },
                                        }}
                                    >
                                        <i className="fas fa-info-circle fa-xs"></i>
                                    </Tooltip>
                                   

                                    

                                </span>
                                {(showCommitPeriodFlag) &&
                                    <span className="indivMandate" style={{ marginLeft: '20px' }}>
                                        <input type='checkbox' name="cb3" id="cb3"
                                            checked={ibsStore.mandateModalInfo.IsInCommitPeriod}
                                            onClick={(e) => onClickCheckbox('IsInCommitPeriod', e)} />
                                        <label htmlFor='cb3'>Is in commitment period?</label>

                                    </span>
                                }

                            </span>

                            {(showCommitPeriodFlag) &&
                                <div className="row">
                                    <div className="col-md-3" style={{ marginTop: '10px' }}>
                                        <span className="comment-heading" style={{ marginRight: '38px' }}>Commitment end year</span>  &nbsp;
                                    </div>
                                    <div className="col-md-9" style={{ marginTop: '10px' }}>
                                        <input type="number" onChange={(e) => onChange('CommitmentEndYear', e)}
                                            className="textInput textFields" name={""} placeholder={"YYYY"} max={"4"}
                                            value={ibsStore.mandateModalInfo.CommitmentEndYear} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                   
                   
                    {showAssetStyleDetails()}
                    
                </React.Fragment>)

        }
        
       return
    }

    const mapStyleOptions = ibsStore.styleOptions.map((style, idx) => {
        if (store.rowDetails) return (<React.Fragment><ul className="assetClassChoice"><a className="assetClassChoice" style={{ fontweight: store.rowDetails.ImplementationStyleName === style.name ? 'bold' : '' }} key={idx} onClick={e => onChangeImplementation(store.rowDetails.AssetClassId, style.id, style.name)}>{style.name}</a></ul></React.Fragment>)
    }
    );

    const mapAssetsForCat = (catID) => {
        let catName = "cat"+ catID
        let assetsAvail = null
        if (ibsStore.assetStylesForCat && ibsStore.assetStylesForCat[catName]) {
            assetsAvail = ibsStore.assetStylesForCat[catName].map((cat, idx) => {
                //if adding asset or benchmark, check if it already exists, if it does - disable the link or remove it (?)
                if (checkIfAssetInTable(cat.Key.AssetClassID, catID)) return null
                // Benchmarks are asset-class level (no styles), so don't gate on countStyles —
                // it counts styles still free in the Assets table and wrongly hides fully-used
                // asset classes from the Add Benchmark picker. checkIfAssetInTable already hides
                // asset classes that are already benchmark rows. See CP-3649.
                if (store.addingBenchmark || (countStyles(catID, cat.Key.AssetClassID)) > 0) return (<ul className="assetClassChoice"><a className="assetClassChoice" style={{ fontWeight: store.rowDetails.AssetClassName === cat.Key.AssetClassName ? 'bold' : '' }} onClick={e => onChangeAssetClass(catID, cat.Key.AssetClassID, cat.Key.AssetClassName)}>{cat.Key.AssetClassName}</a></ul>)
                else return null
            })
        }
        return assetsAvail;
       
    }


    const selectEditText = () => {
        if (store.editingMandate)
        {
            return "Reclassify "
        }
        if (!store.editingMandate) {
            return "Select "
        }
    }
    const template = (dataItem) => {
        return (
            <span className={"k-disabled"}>
                {dataItem.text}
            </span>
        );
    };
    const sizes = [
        {
            id: 1,
            name: "X-Small",
        },
        {
            id: 2,
            name: "Small",
        },
        {
            id: 3,
            name: "Medium",
            disabled: true,
        },
        {
            id: 4,
            name: "Large",
        },
        {
            id: 5,
            name: "X-Large",
            disabled: true,
        },
        {
            id: 6,
            name: "2X-Large",
        },
    ];
    const handleOnChange = (e) => {
        setValue(e.target.value);
    };
    const assetsAvailableList = () => {
        return (<div className="row ">
            <div className="col-md-12">
                <h5 className="addrow-heading" onClick={showHideAssetOptions}><i className={`${store.showAssetOptions ? "fas fa-angle-down" : "fas fa-angle-right"}`} style={{ paddingRight: '10px' }}></i>
                    {selectEditText()}
                    the asset class </h5>

                <div className={`row groupClasses ${store.showAssetOptions ? 'fade-in' : 'fade-out'}`}>
                    <div className="col-md-cus1">
                        <h6 className="comment-heading">Equities </h6>
                        {mapAssetsForCat(1)}
                    </div>

                    <div className="col-md-cus1">
                        <h6 className="comment-heading">Bonds </h6>
                        {mapAssetsForCat(2)}

                    </div>

                    <div className="col-md-cus1">
                        <h6 className="comment-heading">Real assets </h6>
                        {mapAssetsForCat(3)}
                        <br/>
                    <h6 className="comment-heading">Multi-asset</h6>
                        {mapAssetsForCat(4)}
                    </div>

                    <div className="col-md-cus1">
                        <h6 className="comment-heading">Private equity</h6>
                        {mapAssetsForCat(5)}

                        <br /><br />
                        <h6 className="comment-heading">Private debt</h6>
                        {mapAssetsForCat(7)}

                    </div>
                    {!store.addingBenchmark &&
                        <div className="col-md-cus1" style={{width:'30%'}}>
                            <h6 className="comment-heading">Overlays</h6>
                            {mapAssetsForCat(6)}
                        
                        </div>
                    }
                    </div>
                
                <div>
                    {store.rowDetails.AssetClassName && !store.showAssetOptions && <span><span style={{ color: '#6d6d6d', fontWeight: '500', marginLeft: '10px', fontStyle: 'italic' }}>{store.rowDetails.AssetClassName}</span> <br /> <span style={{ color: 'grey', fontWeight: '400', marginLeft: '25px', }}> {store.rowDetails.AssetClassDescription}</span></span>}

                </div>
                {!store.addingBenchmark &&
                    <React.Fragment>
                        <h5 style={{ marginTop: '30px' }} className="addrow-heading" onClick={showHideImpOptions}><i className={`${store.showImplementationOptions ? "fas fa-angle-down" : "fas fa-angle-right"}`} style={{ paddingRight: '10px' }}></i>
                            {selectEditText()}
                            the implementation style </h5>
                        <div className={`row groupClasses ${store.showImplementationOptions ? 'fade-in' : 'fade-out'}`} >
                            <div className="col-md-6">
                                {mapStyleOptions}
                            </div>
                        </div>
                        {store.rowDetails.ImplementationStyleName && !store.showImplementationOptions && <span><span style={{ color: '#6d6d6d', fontWeight: '500', marginLeft: '20px', fontStyle: 'italic' }}>{store.rowDetails.ImplementationStyleName}</span> <br /> <div style={{ color: 'grey', fontWeight: '400', marginLeft: '40px', }}> {store.rowDetails.StyleDescription}</div></span>}

                        {store.showMandateActionModal && ((store.rowDetails.ImplementationStyleName && mandateSubstylesForAsset(ibsStore.mandateModalInfo.AssetClassID, ibsStore.mandateModalInfo.AssetCatID).length > 1) || (store.editingMandate && mandateSubstylesForAsset(ibsStore.mandateModalInfo.AssetClassID, ibsStore.mandateModalInfo.AssetCatID).length > 1)) &&
                            <React.Fragment>
                                <h5 style={{ marginTop: '30px' }} className="addrow-heading" onClick={showHideSubstyleOptions}><i className={`${store.showSubstylesOptions ? "fas fa-angle-down" : "fas fa-angle-right"}`} style={{ paddingRight: '10px' }}></i>
                                    {selectEditText()}
                                    the investment style </h5>

                                <div className={`row groupClasses ${store.showSubstylesOptions ? 'fade-in' : 'fade-out'}`} >
                                    <div className="col-md-9">
                                        <div className="row"> <span style={{ color: 'grey', fontWeight: '400' }}>Choose up to three styles, as applicable.</span></div>

                                        <span className="comment-heading">Mandate Style<sup>*</sup>
                                        </span>
                                    </div>
                                    <div className="col-md-9" style={{ marginTop: '10px' }}>
                                        <MultiSelect
                                            className={"mandateModalSelect"}
                                            data={mandateSubstylesForAssetChosenRemoved(ibsStore.mandateModalInfo.AssetClassID, ibsStore.mandateModalInfo.AssetCatID)}
                                            value={ibsStore.mandateModalInfo.MandateSubstyles}
                                            noDataTemplate={'No Data!'}
                                            onChange={(e) => {
                                                onMandateSubStyleChange(e)
                                            }}
                                        />
                                       
                                    </div>
                                </div>
                            </React.Fragment>
                        }

                    </React.Fragment>
                }

            </div>
        </div>)
    }

    // Disables buttons when adding or editing a mandate and there is no manager or fund name.
    const blockNoNameMandate = () => {
        if (store.addingNewMandate || store.editingMandate) {
            if (ibsStore.mandateModalInfo.ManagerName == "" || ibsStore.mandateModalInfo.FundName == "") {
                return true;
            }
        }
        return false;
    }
    const onMandateSubStyleChange = (e, qId) => {
        //setValue(e.target.value.slice(0, 3));
        ibsStore.mandateModalInfo.MandateSubstyles = e.target.value.slice(0, 3)
        


    }
    const onRegionChange = (e, qId) => {
        //setValue(e.target.value.slice(0, 3));
        ibsStore.mandateModalInfo.MandateRegionID = e.target.value


    }
    return (
        <React.Fragment>
            <section className = "generalModal">
                <Modal
                    visible={store.showAddRowModal || store.showMandateActionModal}
                    width="950"
                    className="testClass"
                    effect="fadeInDown"
                    onClickAway={closeAddRowModal} >
                    <div className="commentModal addNewRowModal" id="addRowModal">
                        {renderModalTitle()}
                        <hr />

                        {mandateOnlySection()}
                        <br />
                        {assetsAvailableList()}

                        {store.editingMandate &&
                            <React.Fragment>
                            <button type="button" className="btn btn-close" onClick={saveMandateModal} disabled={ibsStore.mandateModalInfo.StyleName == "" || blockNoNameMandate()}>
                                Save mandate
                            </button>
                            <button type="button" className="btn btn-close btn-remove" onClick={deleteMandate}>Delete mandate</button>

                            </React.Fragment>
                        }

                        {(!store.addingNewMandate && !store.editingMandate) &&
                            <button type="button" className="btn btn-close" disabled={
                            (!store.addingBenchmark && store.rowDetails.ImplementationStyleName == "") || (store.addingBenchmark && store.rowDetails.AssetClassId === "")}
                            onClick={saveRow}>Add</button>
                        }
                        
                        {store.addingNewMandate &&
                            <button type="button" className="btn btn-close" disabled={ibsStore.mandateModalInfo.StyleName == "" || blockNoNameMandate()} 
                                onClick={addNewMandate}>Add mandate</button>

                        }
                        <button type="button" className="btn btn-close grey" onClick={closeAddRowModal}>Cancel</button>
                        <br />
                        {(store.addingNewMandate || store.editingMandate) && <span className="comment-heading"><sup>*</sup><em>These fields are mandatory.</em></span>}
                    </div>
                </Modal>
            </section>
        </React.Fragment>
    );

});

export default AddRowModal;
